import { useQuery } from "@tanstack/react-query";
import { useErrorContext } from "@shared/src/contexts/ErrorContext";
import { orderService } from "@shared/src/services/order.service";
import { OrderResponse, OrdersQuery, OrderStateKey } from "@sdk/shared/types/order.types";
import { P2P_ORDERS_QUERY_KEY } from "@shared/src/lib/queryKeys";
import { IN_PROGRESS_STATES } from "@shared/src/constants";
import { getExpiryTime } from "@shared/src/lib/functions";
import type { UseQueryResult } from "@tanstack/react-query";

export type FilterValue =
  | "all"
  | "expired"
  | "in_progress"
  | "intent"
  | "unpaid"
  | "paid"
  | "released"
  | "cancelled"
  | "appealed";
export interface OrdersQueryParams extends Omit<OrdersQuery, "state"> {
  page: number;
  limit: number;
  state: FilterValue;
}

export interface UseOrdersQueryResponse {
  orders: OrderResponse[] | null;
  totalItems: number;
  hasMore: boolean;
}

export function useP2POrders(params: OrdersQueryParams): UseQueryResult<UseOrdersQueryResponse, unknown> {
  const { addError } = useErrorContext();
  console.log({ params });

  const ret = useQuery({
    queryKey: P2P_ORDERS_QUERY_KEY(params),
    queryFn: async () => {
      let expiryAfter: number | undefined = undefined;
      let expiryBefore: number | undefined = undefined;

      const states: (OrderStateKey | undefined)[] = [];
      switch (params.state) {
        case "in_progress":
          states.push(...IN_PROGRESS_STATES);
          expiryAfter = getExpiryTime();
          break;
        case "unpaid":
          states.push("pending", "accepted");
          break;
        case "expired":
          expiryBefore = getExpiryTime();
          states.push("intent");
          break;
        case "all":
          states.push(undefined);
          break;
        default:
          states.push(params.state);
          break;
      }
      console.log("params ret", params);

      const results = await orderService.getOrders({ ...params, state: states.join(","), expiryAfter, expiryBefore });

      const hasMore = results.data?.length === params.limit;

      return {
        orders: results.data,
        totalItems: results.data?.length,
        hasMore,
      } as UseOrdersQueryResponse;
    },
    refetchOnWindowFocus: true,
  });
  console.log({ ret, params });
  return ret;
}
